export default [
  {
    title: '规则ID',
    key: 'ruleId',
    width: 64
  },
  {
    title: '开关',
    key: 'enable',
    width: 50
  },
  {
    title: '规则名称',
    key: 'ruleName',
    width: 152
  },
  {
    title: '触发条件',
    key: 'ruleMsg',
    width: 210
  },
  {
    title: '规则类型',
    key: 'ruleType',
    width: 140
  },
  {
    title: '监测频率',
    key: 'monitorTimes',
    width: 140
  },
  {
    title: '账号数',
    key: 'accountNum',
    width: 64,
    align: 'center'
  },
  // {
  //   title: '提醒人员',
  //   key: 'alertOpNames',
  //   width: 200,
  //   overflow: true
  // },
  // {
  //   title: '媒体',
  //   key: 'mediaNames',
  //   width: 140
  // },
  {
    title: '创建人',
    key: 'opName',
    width: 84
  },
  {
    title: '最后操作人',
    key: 'upOpName',
    width: 84
  },
  {
    title: '更新时间',
    key: 'ruleModifyTime',
    width: 140
  },
  {
    title: '最后暂停/启动时间',
    key: 'enableModifyTime',
    width: 140
  },
  {
    title: '操作',
    key: 'control',
    width: 104
  }
]
